import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography, Modal, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DeleteDiscount } from "../types/discounts";
import { deleteDiscount } from "../apis/discounts";

const closeIconStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "end",
  marginBottom: 1,
};

const DiscountDeleteModal = (props: DeleteDiscount) => {
  const { deleteId, openState, dataset, setData, setOpenState, fetchUpdatedData } = props;

  const handleDiscountDeleteClose = () => setOpenState(false);

  const deleteRecord = async () => {
    //console.log("deleteId: ", deleteId);
    const res = await deleteDiscount(deleteId);
    if (res?.status) {
      fetchUpdatedData();
      handleDiscountDeleteClose();
    }
  };

  return (
    <>
      <Modal
        open={openState}
        onClose={handleDiscountDeleteClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box>
            <Box sx={closeIconStyle}>
              <CloseIcon sx={{ cursor: "pointer" }} onClick={handleDiscountDeleteClose} />
            </Box>
            <Box style={{ marginBottom: "30px" }}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Delete Discount
              </Typography>
            </Box>
          </Box>
          <Box
            style={{
              paddingBottom: "20px",
            }}
          >
            Do you want delete this discount?
          </Box>

          <Box sx={closeIconStyle}>
            <Button variant="contained" onClick={deleteRecord}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DiscountDeleteModal;
